import "./datadog";

import "./reset.css";

import "@teamworksdev/style/dist/index.css";
import "@teamworksdev/style/dist/scrollbars.css";

import "./index.css";

import ReactDOM from "react-dom/client";
import Axle from "./Axle";
import { withTWLaunchDarklyProvider } from "./services/launchDarkly";

// Strip www. to match the registered Okta redirect URI
if (window.location.hostname.startsWith("www.")) {
  const url = new URL(window.location.href);
  url.hostname = url.hostname.replace(/^www\./, "");
  window.location.replace(url.toString());
} else {
  const LDProvider = withTWLaunchDarklyProvider(Axle);

  // biome-ignore lint/style/noNonNullAssertion: root element is guaranteed to exist
  ReactDOM.createRoot(document.getElementById("root")!).render(<LDProvider />);
}
